import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  computed,
  contentChild,
  input,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

@Directive({
  selector: '[emptyPlaceholderIllustration]',
})
export class EmptyPlaceholderIllustrationDirective {}

@Directive({
  selector: '[emptyPlaceholderActions]',
})
export class EmptyPlaceholderActionsDirective {}

@Component({
  selector: 'ct-lib-empty-placeholder',
  templateUrl: './empty-placeholder.component.html',
  styleUrls: ['./empty-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent],
})
export class EmptyPlaceholderComponent {
  readonly icon = input<IconProp | null>(null);
  readonly title = input.required<string>();
  readonly text = input.required<string>();

  private readonly illustrationSlot = contentChild(
    EmptyPlaceholderIllustrationDirective
  );
  private readonly actionsSlot = contentChild(EmptyPlaceholderActionsDirective);

  readonly hasIllustration = computed(() => !!this.illustrationSlot());
  readonly hasActions = computed(() => !!this.actionsSlot());
}
